import {doc} from './docs.js';
import {mod} from "utils/mod.js";

doc(
    "+",
    {
    },
    "Adds the inlets together outputting it from the outlet",
    undefined,
    {
        isHot: true,
        inlets: 2,
        tags: ["Math"],
    }
);

export const add = (object, a) => {
    return (msg) => {
        if (Array.isArray(msg[0])) {
            return [msg[0].map((x,i) =>
                Array.isArray(a()) ?
                    isNaN(x) || isNaN(a()[i]) ? x :
                    x + a()[i] : x + a())];
        }
        let x = a() + msg[0];
        if (isNaN(x)) {
            return 1;
        }
        return x;
    };
};

doc(
    "-",
    {
    },
    "Subtracts the 2nd inlet from the 1st, outputting it from the outlet",
    undefined,
    {
        isHot: true,
        inlets: 2,
        tags: ["Math"],
    }
);

export const subtract= (object, a) => {
    return (msg) => {
        if (Array.isArray(msg[0])) {
            return [msg[0].map((x,i) => Array.isArray(a()) ? x - a()[i] : x - a())];
        }
        let x = msg[0] - a();
        if (isNaN(x)) {
            return 1;
        }
        return x;
    };
};

doc(
    "*",
    {
    },
    "Multiplies the left and right inlets together",
    undefined,
    {
        isHot: true,
        inlets: 2,
        tags: ["Math"],
    }
);

export const multiply = (object, a) => {
    return (msg) => {
        if (Array.isArray(msg[0])) {
            return [msg[0].map((x, i) =>
                Array.isArray(a()) ?
                    isNaN(x) || isNaN(a()[i%a().length]) ? x  : x * a()[i%a().length] :
                isNaN(a()) || isNaN(x) ? x : x * a())];
        }
        let x = a() * msg[0];
        if (isNaN(x)) {
            return 1;
        }
        return x;
    };
};

doc(
    "/",
    {
    },
    "Divides the left and right inlets together",
    undefined,
    {
        isHot: true,
        tags: ["Math"],
        inlets: 2,
    }
);

export const divide = (object, a) => {
    return (msg) => {
        if (Array.isArray(msg[0])) {
            return [msg[0].map((x, i) => Array.isArray(a()) ? x / a()[i] : x / a())];
        }
        let x = msg[0] / a();
        if (isNaN(x)) {
            return 1;
        }
        return x;
    };
};

doc(
    "pow",
    {
        "a":"",
        b: ""
    },
    "Returns left inlet raised to power of right inlet",
    undefined,
    {
        inlets: 2,
        isHot: true,
        tags: ["Math"],
    }
);

export const pow = (object, a) => {
    return (msg) => {
        let _a = a();
        if (isNaN(_a)) {
            _a = 1;
        }
        let n = msg[0];
        if (Array.isArray(n)) {
            return [n.map(x => Math.pow(x, _a))];
        } else {
            return Math.pow(msg[0], _a);
        }
    };
};

doc(
    "sqrt",
    {
    },
    "Returns square-root of left inlet",
    undefined,
    {
        tags: ["Math"],
    }
);

export const sqrt = () => {
    return (msg) => {
        return Math.sqrt(msg[0]);
    };
};

doc(
    "sin",
    {
    },
    "Returns sine of left inlet",
    undefined,
    {
        tags: ["Math"],
    }
);

export const sin= () => {
    return (msg) => {
        return Math.sin(msg[0]);
    };
};

doc(
    "cos",
    {
    },
    "Returns cosine of left inlet",
    undefined,
    {
        tags: ["Math"],
    }
);

export const cos= () => {
    return (msg) => {
        return Math.cos(msg[0]);
    };
};


doc(
    "round",
    {
    },
    "Returns rounded value of left inlet",
    undefined,
    {
        tags: ["Math"],
    }
);

export const round = () => {
    return (msg) => {
        let x = Math.round(msg[0]);
        if (isNaN(x)) {
            return undefined;
        }
        return x;
    };
};

doc(
    "floor",
    {
    },
    "Returns floored value of left inlet",
    undefined,
    {
        tags: ["Math"],
    }
);

export const floor = () => {
    return (msg) => {
        let x = Math.floor(msg[0]);
        if (isNaN(x)) {
            return undefined;
        }
        return x;
    };
};



doc(
    "%",
    {
        "a": ""
    },
    "Returns remainder of the left-inlet divided by the right-inlet",
    undefined,
    {
        inlets: 2,
        isHot: true,
        tags: ["Math"]
    }
);

export const modFn = (object, a) => {
    return ([msg]) => {
        if (Array.isArray(msg)) {
            let _a = a();
            return [msg.map(x => mod(x, _a))];
        } else {
            return mod(msg, a());
        }
    };
};

doc(
    "remainder",
    {
        "a": ""
    },
    "Returns remainder and divider of the left-inlet divided by the right-inlet",
    () => 2,
    {
        inlets: 2,
        isHot: true,
        tags: ["Math"]
    }
);

export const remainder = (object, a) => {
    return (msg) => {
        return [[mod(msg[0], a()), Math.floor(msg[0]/a())]];
    };
};

doc(
    "abs",
    {
        "a": ""
    },
    "Returns absolute value of the left-inlet",
    undefined,
    {
        inlets: 1,
        tags: ["Math"]
    }
);

export const abs = (object) => {
    return (msg) => {
        if (Array.isArray(msg[0])) {
            return [msg[0].map(x => Math.abs(x))];
        }
        return Math.abs(msg[0]);
    };
};

doc(
    "max",
    {
        "a": "",
        "b": ""
    },
    "Returns max value of the left-inlet and right-inlet",
    undefined,
    {
        inlets: 2,
        tags: ["Math"]
    }
);

export const max = (object, b) => {
    return (msg) => {
        return Math.max(msg[0], b());
    };
};

doc(
    "min",
    {
        "a": "",
        "b": ""
    },
    "Returns min value of the left-inlet and right-inlet",
    undefined,
    {
        inlets: 2,
        tags: ["Math"]
    }
);

export const min = (object, b) => {
    return (msg) => {
        return Math.min(msg[0], b());
    };
};


doc(
    "hexalist",
    {
        number: "",
    },
    "Convert a number in base 10 to a list of numbers from 0-15 (i.e. hexa)",
    undefined,
    {
        inlets: 1
    });

export const hexalist = (object) => {
    return (msg) => {
        let hexa = msg[0].toString(16);
        let list = [];
        for (let i=0; i < hexa.length; i++ ){
            list.push(parseInt(hexa[i], 16));
        }
        return [list];
    };
};

doc(
    "clamp",
    {
        "a": "",
        "b": "",
        "c": "",
    },
    "Returns clamped value of inlet",
    undefined,
    {
        inlets: 2,
        isHot: true,
        tags: ["Math"]
    }
);

export const clamp = (object, a, b) => {
    return (msg) => {
        return Math.min(Math.max(msg[0], a()), b());
    };
};


doc(
    "pi",
    {},
    "Returns value for pi when it receives a message"
);

export const pi = (object) => {
    return () => {
        return Math.PI;
    };
};

export const math = {
    '+': add,
    pi,
    min,
    max,
    clamp,
    '-': subtract,
    '*': multiply,
    '/': divide,
    '%': modFn,
    'pow': pow,
    'sqrt': sqrt,
    'round': round,
    floor,
    abs,
    hexalist,
    remainder,
    sin,
    cos
};


